import type React from 'react';

/** @deprecated Use icons from icons-v2-generated instead. */
export interface OrganizationsIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function OrganizationsIcon({ className, color = 'white', ...props }: OrganizationsIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M20.8745 7C20.8745 5.96447 20.035 5.125 18.9995 5.125H5C3.96447 5.125 3.125 5.96447 3.125 7V17.0005C3.12526 18.0358 3.96463 18.8755 5 18.8755H18.9995C20.0349 18.8755 20.8742 18.0358 20.8745 17.0005V7ZM23.1245 17.0005C23.1242 19.2784 21.2775 21.1255 18.9995 21.1255H5C2.72199 21.1255 0.875264 19.2784 0.875 17.0005V7C0.875 4.72183 2.72183 2.875 5 2.875H18.9995C21.2777 2.875 23.1245 4.72183 23.1245 7V17.0005Z"
        fill={color}
      />
      <path
        d="M11.1245 16.5C11.1245 15.7408 10.5097 15.1248 9.75049 15.1245H8.25049C7.4911 15.1245 6.875 15.7406 6.875 16.5C6.875 17.1213 6.37132 17.625 5.75 17.625C5.12868 17.625 4.625 17.1213 4.625 16.5C4.625 14.498 6.24846 12.8745 8.25049 12.8745H9.75049C11.7523 12.8748 13.3745 14.4981 13.3745 16.5C13.3745 17.1213 12.8708 17.625 12.2495 17.625C11.6284 17.6247 11.1245 17.1212 11.1245 16.5ZM18.0005 11.8755L18.1147 11.8813C18.6821 11.9389 19.1255 12.4179 19.1255 13.0005C19.1252 13.5829 18.682 14.0622 18.1147 14.1196L18.0005 14.1255H15.5C14.8788 14.1255 14.3753 13.6216 14.375 13.0005C14.375 12.3792 14.8787 11.8755 15.5 11.8755H18.0005ZM9.75049 9.375C9.75049 8.96095 9.41448 8.62526 9.00049 8.625C8.58627 8.625 8.25049 8.96079 8.25049 9.375C8.25049 9.78921 8.58627 10.125 9.00049 10.125C9.41448 10.1247 9.75049 9.78905 9.75049 9.375ZM18.0005 7.875L18.1147 7.88086C18.6822 7.93835 19.1255 8.41742 19.1255 9C19.1255 9.58258 18.6822 10.0617 18.1147 10.1191L18.0005 10.125H15.5C14.8787 10.125 14.375 9.62132 14.375 9C14.375 8.37868 14.8787 7.875 15.5 7.875H18.0005ZM12.0005 9.375C12.0005 11.0317 10.6571 12.3747 9.00049 12.375C7.34363 12.375 6.00049 11.0319 6.00049 9.375C6.00049 7.71815 7.34363 6.375 9.00049 6.375C10.6571 6.37526 12.0005 7.71831 12.0005 9.375Z"
        fill={color}
      />
    </svg>
  );
}
